const homolog = "https://queroquitar-hml.2be.tools";
const local = homolog;

const prod = "https://queroquitar.2be.tools/";

const baseUrls = { homolog, local, prod };
const href = window.location.href;
// const isDev = href.includes("localhost") ? true : false;

const isLocal = href.includes("localhost") ? "local" : null;
const isHml = href.includes("-hml") ? "homolog" : null;

const environment = isHml || isLocal || "prod";
const getBaseUrl = (env = environment) => baseUrls[env];

export default getBaseUrl();
